import { css } from '@emotion/react';
import { margins } from '@spotnana/blocks/src/utils';

export const checkout_container = (showLLFBannerAlert: boolean) => css`
  .BlocksPreferredLabel-root {
    ${showLLFBannerAlert && margins.yt.m1point5}
  }
`;
